<template>
  <div class="root-curvature-section">
    <div v-if="question.measurementImageBase64" class="measurement-results">
      <div class="measurement-image">
        <img :src="question.measurementImageBase64" @click="$emit('show-image', question.measurementImageBase64)" />
        <div class="measurement-angle">
          <strong>Measured Angle:</strong> {{ question.measurementAngle }}°
        </div>
      </div>
      <button class="btn-measure edit" @click="$emit('show-measurement-tool')">
        <svg class="btn-icon" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg>
        Edit Measurement
      </button>
    </div>
    <div v-else class="measurement-prompt">
      <p>Please use the measurement tool to measure root curvature before selecting a response.</p>
      <button class="btn-measure" @click="$emit('show-measurement-tool')">
        <svg class="btn-icon" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z" /></svg>
        Load Measurement Tool
      </button>
    </div>

    <!-- The ResponseGrid is only shown after a measurement has been made -->
    <ResponseGrid
      v-if="question.measurementImageBase64"
      :responses="sortedResponses"
      :is-disabled="!question.measurementImageBase64"
      @select-response="$emit('select-response', $event)"
      @show-image="$emit('show-image', $event)"
      @show-information="$emit('show-information', $event)"
    />
  </div>
</template>

<script>
import ResponseGrid from './ResponseGrid.vue';

export default {
  name: 'RootCurvatureQuestion',
  components: {
    ResponseGrid,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  emits: ['select-response', 'show-measurement-tool', 'show-image', 'show-information'],
  computed: {
    sortedResponses() {
      return [...this.question.responses].sort((a, b) => a.position - b.position);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../breakpoints.scss";

.root-curvature-section {
  padding: 16px;

  .measurement-prompt {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 15px 0;
    text-align: center;
    background: #F9FAFB;
    border: 1px dashed #D1D5DB;
    border-radius: 8px;
    padding: 20px;

    p {
      margin-bottom: 15px;
      font-weight: 500;
      color: #000001;
    }
  }

  .measurement-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    background: #F9FAFB;
    border-radius: 8px;
    padding: 16px;

    @include md {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    .measurement-image {
      margin-bottom: 15px;
      text-align: center;

      @include md {
        margin-bottom: 0;
        margin-right: 20px;
        flex: 1;
      }

      img {
        max-width: 100%;
        max-height: 200px;
        border: 1px solid #E5E7EB;
        border-radius: 8px;
        cursor: pointer;

        &:hover {
          border-color: #013B82;
        }
      }

      .measurement-angle {
        margin-top: 12px;
        font-size: 16px;
        color: #111827;
        background: white;
        border-radius: 6px;
        padding: 8px 12px;
        display: inline-block;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      }
    }
  }

  .btn-measure {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.2s ease;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #013B82, #0A2D5C);
    color: white;
    box-shadow: 0 2px 6px rgba(1, 59, 130, 0.2);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(1, 59, 130, 0.3);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(1, 59, 130, 0.2);
    }

    &.edit {
      background: linear-gradient(135deg, #000001, #374151);
      padding: 8px 16px;
      font-size: 14px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      &:hover {
        background: linear-gradient(135deg, #374151, #1F2937);
      }
    }

    .btn-icon {
      flex-shrink: 0;
    }
  }
}
</style>